// extracted by mini-css-extract-plugin
export default {"container":"XYQH8F3LoOCoCeaTOePg","h1":"jrTmfs7KgtJkMEam2QmY","h2":"JLKrBoqkFWMoxIytVZqj","ol":"dl4Va8UzFIE1UrVAgTMw","ul":"oXKO2zuhzjTJhpcoIfQ1"};